<template>
    <BContainer style="max-width: 540px;">
        <BCard v-show="isOrgAdmin">
            <BCardHeader class="p-4">
                <h1 class="h4">
                {{ $t('pages.orgAdminPromotion.pageTitle') }}
                </h1>
            </BCardHeader>
            <BCardBody>
                <ValidationObserver
                    ref="observer"
                    v-slot="{ invalid }">
                    <slot>
                        <BForm>
                            <BFormGroup
                            :key="'userName'">
                                <FrField
                                    v-model="saveDetails.userName"
                                    :label="'User Email Address (Required)'"
                                    :type="'string'"
                                    :validation="'required'"/>
                            </BFormGroup>
                            <BFormGroup
                            :key="'description'">
                                <FrField
                                    v-model="saveDetails.description"
                                    :label="'Reason for Promotion Request (Required)'"
                                    :type="'string'"
                                    :validation="'required'" />
                            </BFormGroup>
                            <BFormGroup
                            :key="'demoteAdmin'">
                                <FrField
                                    v-model="removeAdmin"
                                    :label="'Remove current Admin privileges'"
                                    :type="'checkbox'" />
                            </BFormGroup>
                        </BForm>
                        <BRow class="justify-content-end">
                            <BCol md="4">
                                <BButton
                                    @click="save"
                                    variant="primary"
                                    :disabled="invalid"
                                    class="align-self-end">
                                    {{ $t('pages.orgAdminPromotion.save') }}
                                </BButton>
                            </BCol>
                        </BRow>
                    </slot>
                </ValidationObserver>
            </BCardBody>
        </BCard>
        <div v-show="!isOrgAdmin">
            <div>{{$t('pages.orgAdminPromotion.accessDenied')}}</div>
        </div>
    </BContainer>
</template>
<script>
import {
    BCard,
    BCardBody,
    BCardHeader,
    BCol,
    BRow,
    BButton,
    BFormGroup,
    BForm,
    BContainer
  } from 'bootstrap-vue';
import NotificationMixin from '@forgerock/platform-shared/src/mixins/NotificationMixin';
import RestMixin from '@forgerock/platform-shared/src/mixins/RestMixin';
import { mapState } from 'vuex';
import FrField from '@forgerock/platform-shared/src/components/Field';
import { ValidationObserver } from 'vee-validate';
export default {
    name: 'orgAdminPromotion',
    components: {
        BCard,
        BCardBody,
        BCardHeader,
        BCol,
        BRow,
        BButton,
        BFormGroup,
        BForm,
        FrField,
        BContainer,
        ValidationObserver,
    },
    mixins: [
        NotificationMixin,
        RestMixin,
    ],
    directives: {
    },
    props: {
    },
    computed: {
        ...mapState({
            internalUser: (state) => state.UserStore.internalUser,
            userId: (state) => state.UserStore.userSearchAttribute,
            userName: (state) => state.UserStore.userName,
            userUid: (state) => state.UserStore.userId,
        })
    },
    data() {
        var data = {
            saveDetails: {
                userName: '',
                description: ''
            },
            removeAdmin: false,
            defName: 'BasicUserPromotionRequest',
            isOrgAdmin: false
        };
        return data;
    },
    mounted() {
        var loginServiceInstance = this.getRequestService();
        loginServiceInstance.get('managed/user/' + this.userUid)
            .then((loggedInUserResponse) => {
                var result = loggedInUserResponse.data;
                console.log(result);
                this.isOrgAdmin = result.isOrganizationAdmin?true:false;
            });
    },
    methods: {
        save () {
            var loggedInUser, formUser, wfdata, i, adminCnt = 0, item, loginServiceInstance, basicUser;
            if (this.saveDetails.userName !== undefined) {
                loginServiceInstance = this.getRequestService();
                loginServiceInstance.get('managed/user?_queryFilter=userName+eq+"' + this.saveDetails.userName + '"')
                    .then((formUserResponse) => {
                        var result = formUserResponse.data['result'];
                        if (result && result[0]) {
                            basicUser = result[0];
                            formUser = result[0].organization;
                            loginServiceInstance.get('managed/user/' + this.userUid)
                                .then((loggedInUserResponse) => {
                                    var result = loggedInUserResponse.data;
                                    loggedInUser = result.organization;
                                    if (formUser === loggedInUser) {
                                        loginServiceInstance.get('managed/user?_queryId=query-all')
                                            .then((queryAll) => {
                                                result = queryAll.data['result'];
                                                for (i = 0; i < result.length; i++) {
                                                    item = result[i];
                                                    if (item.isOrganizationAdmin) {
                                                        adminCnt++;
                                                    }
                                                }
                                                if (this.removeAdmin === undefined || this.removeAdmin === null || this.removeAdmin === '') {
                                                    this.removeAdmin = false;
                                                }
                                                let executeCall = false;
                                                if (this.removeAdmin && adminCnt > 1) {
                                                    executeCall = true;
                                                } else if (!this.removeAdmin) {
                                                    executeCall = true;
                                                }
                                                console.log('Remove admin: ' + this.removeAdmin + ' ExecuteCall: ' + executeCall + ' Admin count:' + adminCnt);
                                                if (executeCall) {
                                                    this.workflowService = this.getRequestService();
                                                    wfdata = JSON.stringify({
                                                        '_key': this.defName,
                                                        'userName': `${this.saveDetails.userName}`,
                                                        'description': `${this.saveDetails.description}`,
                                                        'userId': `${basicUser._id}`
                                                    });

                                                    this.workflowService.post('/workflow/processinstance/?_action=create', wfdata)
                                                        .then((response) => {
                                                            // console.log('Response: ' + response);
                                                            wfdata = JSON.stringify([{
                                                                'operation': 'replace',
                                                                'field': '/promotionDescription',
                                                                'value': `${this.saveDetails.description}`
                                                            },
                                                            {
                                                                'operation': 'replace',
                                                                'field': '/promotingAdmin',
                                                                'value': `${this.userName}`
                                                            },
                                                            {
                                                                'operation': 'replace',
                                                                'field': '/promotingAdminRemove',
                                                                'value': `${this.removeAdmin}`
                                                            },
                                                            {
                                                                'operation': 'replace',
                                                                'field': '/promotionInProgress',
                                                                'value': 'true'
                                                            }
                                                            ]);
                                                            loginServiceInstance.patch('managed/user/' + basicUser['_id'], wfdata).then((updatedUserResponse) => {
                                                                this.displayNotification('success', this.$t('pages.orgAdminPromotion.successMessage'));
                                                                this.$router.push({
                                                                    name: 'Dashboard'
                                                                });
                                                            }).catch((error) => {
                                                                error = undefined;
                                                                this.displayNotification('error', this.$t('pages.orgAdminPromotion.failureMessage'));
                                                            });
                                                        })
                                                        .catch((error) => {
                                                            error = undefined;
                                                            this.displayNotification('error', this.$t('pages.orgAdminPromotion.failureMessage'));
                                                        });
                                                } else {
                                                    this.displayNotification('error', this.$t('pages.orgAdminPromotion.orgAdminZero'));
                                                }
                                            })
                                            .catch(function (error) {
                                                error = undefined;
                                            });
                                        
                                    } else {
                                        this.displayNotification('error', this.$t('pages.orgAdminPromotion.unauthorized'));
                                    }
                                })
                                .catch(function (error) {
                                    error = undefined;
                                    this.displayNotification('error', this.$t('pages.orgAdminPromotion.failureMessage'));
                                });
                        } else {
                            console.log("USER NOT FOUND");
                            this.displayNotification('error', this.$t('pages.orgAdminPromotion.userNotFound'));
                        }
                    })
                    .catch(function (error) {
                        error = undefined;
                    });
            }
        }
    }
};
</script>